/** Plain text from HTML (for cards, previews, meta). */
export function stripHtml(input: string): string {
  return (input || '')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

export function looksLikeHtml(input: string): boolean {
  return /<[a-z][\s\S]*>/i.test(input || '');
}
